<template>
  <div>
    <!-- Bottone LEGENDA -->
    <v-btn color="grey lighten-3" class="text-capitalize align-left" @click="toggleFooter" block tile elevation="0">
      <v-icon left>
        {{ isVisible ? "mdi-chevron-down" : "mdi-chevron-up" }}
      </v-icon>
      {{ isVisible ? $t("hideLegend") : $t("showLegend") }}
    </v-btn>

    <!-- Pannello legenda -->
    <div v-if="isVisible" class="legend-panel">
      <v-card class="pa-3 legend-card" elevation="6" tile color="rgba(255, 255, 255, 0.7)">
        <v-container fluid>
          <v-row no-gutters>
            <v-col cols="12" sm="3">
              <div class="legend-section-title">
                {{ $t("convoyStatus") }}
              </div>
              <v-row>
                <v-col cols="12">
                  <div class="text-caption font-weight-regular">
                    <v-icon style="text-decoration: none" depressed small color="amber"> mdi-progress-clock </v-icon>
                    {{ $t("working") }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="4">
              <div class="legend-section-title">
                {{ $t("movementStatus") }}
              </div>
              <v-row>
                <v-col cols="6">
                  <div class="text-body-2 font-weight-regular mb-1">
                    {{ $t("arrival") }}
                  </div>
                  <calLegend :details="utiWagonStatesExport" />
                </v-col>
                <v-col cols="6">
                  <div class="text-body-2 font-weight-regular mb-1">
                    {{ $t("departure") }}
                  </div>
                  <calLegend :details="utiWagonStatesImport" />
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" sm="5">
              <div class="legend-section-title">
                {{ $t("characteristics") }}
              </div>
              <v-row>
                <v-col cols="6">
                  <div class="text-body-2 font-weight-regular mb-1">
                    {{ $t("uti") }}
                  </div>
                  <calLegend :details="utiFeaturesLegendVoices" />
                </v-col>
                <v-col cols="6">
                  <div class="text-body-2 font-weight-regular mb-1">
                    {{ $t("wagon") }}
                  </div>
                  <calLegend :details="wagonFeaturesLegendVoices" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>

        <!-- Bottone chiudi -->
        <div class="legend-close-btn">
          <v-btn icon small @click="toggleFooter">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import calLegend from "../../components/misc/Legend";

export default {
  name: "LegendFooter",
  components: {
    calLegend,
  },
  props: {
    utiWagonStatesExport: Object,
    utiWagonStatesImport: Object,
    utiFeaturesLegendVoices: Object,
    wagonFeaturesLegendVoices: Object,
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    toggleFooter() {
      this.isVisible = !this.isVisible;
    },
  },
};
</script>

<style scoped>
.legend-panel {
  position: fixed;
  bottom: 16px;
  bottom: 120%;
  width: 880px;
  z-index: 1000;
}

.legend-card {
  max-height: 320px;
  overflow-y: auto;
  position: relative;
}

.legend-section-title {
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 4px;
  margin-bottom: 12px;
  color: #424242;
}

/* Spazio sotto ogni blocco */
.v-col > div {
  margin-bottom: 12px;
}

/* Bottone chiusura */
.legend-close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
}
</style>
